import React, { useEffect } from "react";
import "../about/about.css";
import logopng from "../../../assets/logo-willalwaysloveu.png";
import { useNavigate } from "react-router-dom";
import { useUserContext } from "../../../context/MemorialContext";

function Cancel() {
  const navigate = useNavigate();
  const { resetMemorialWizard } = useUserContext();

  useEffect(() => {
    // Abandoned Stripe: drop payment keys AND loved-one draft so Free/new create
    // cannot reuse unverified memorial details (they are not editable later).
    if (typeof resetMemorialWizard === "function") {
      resetMemorialWizard({ keepNames: false });
    }
  }, [resetMemorialWizard]);

  return (
    <div className="aboutpage">
      <div className="ab-top">
      <img
        src={logopng}
        className="payment-status-logo"
        alt="WillAlwaysLoveU — online memorial website logo"
      />
        <div className="content1">
          <p className="tp">Payment Failed</p>
          <p className="btm">
            At willalwaysloveu, we provide a shared, easily-accessible virtual
            space where family members and friends can pay homage to a special
            life while helping each other heal by sharing their feelings, warm
            memories, and words of support.
          </p>
          <button
            className="memobtn"
            onClick={() => {
              navigate("/");
            }}
          >
            Return to home page
          </button>
        </div>
      </div>

      <div className="triagnle"></div>
      <div className="ab-bottom"></div>
    </div>
  );
}

export default Cancel;
